import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ThemeProvider } from './contexts/ThemeContext';
import Sidebar from './components/Sidebar';
import Login from './pages/Login';
import Register from './pages/Register';
import Subscribe from './pages/Subscribe';
import { ProtectedRoute } from './components/ProtectedRoute';
import { UnauthenticatedRoute } from './components/UnauthenticatedRoute';
import MusicCRMLanding from './pages/LandingPage';
import Dashboard from './pages/Dashboard';
import Fans from './pages/Fans';
import Guests from './pages/Guests';
import Campaigns from './pages/Campaigns';
import Affliates from './pages/Affiliates';
import CreateCampaign from './pages/CreateCampaign';
import SmartLinks from './pages/SmartLinks';
import Setting from './pages/Settings';
import CampaignDetail from './pages/CampaignDetail';
import Pricing from './pages/Pricing';
import About from './pages/About';
import Contact from './pages/Contact';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import CampaignDetails from './pages/CampaignDetails';
import { AuthProvider } from './contexts/AuthContext'
import { Toaster } from 'sonner';
import './App.css';
import PublicSmartLink from './pages/PublicSmartLink';

import MobileNav from './components/MobileNav';

function ProtectedShell({ children }) {
  return (
    <div className="min-h-screen bg-white dark:bg-black">
      <MobileNav />
      <div className="flex">
        <Sidebar />
        <main className="flex-1 md:ml-64">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="p-4 sm:p-6 lg:p-8 bg-white dark:bg-black"
          >
            {children}
          </motion.div>
        </main>
      </div>
    </div>
  );
}

function App() {
  return (
      <AuthProvider>
    <ThemeProvider >
      <Router>
        <Routes>
          <Route path="/" element={<MusicCRMLanding />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/subscribe/:priceId" element={<Subscribe />} />

          {/* Explicit protected routes */}
          <Route path="/dashboard" element={<ProtectedRoute><ProtectedShell><Dashboard /></ProtectedShell></ProtectedRoute>} />
          <Route path="/fans" element={<ProtectedRoute><ProtectedShell><Fans /></ProtectedShell></ProtectedRoute>} />
          <Route path="/affiliates" element={<ProtectedRoute><ProtectedShell><Affliates /></ProtectedShell></ProtectedRoute>} />
          <Route path="/guests" element={<ProtectedRoute><ProtectedShell><Guests /></ProtectedShell></ProtectedRoute>} />
          <Route path="/campaigns" element={<ProtectedRoute><ProtectedShell><Campaigns /></ProtectedShell></ProtectedRoute>} />
          {/* New canonical campaign details route */}
          <Route path="/campaigns/:id" element={<ProtectedRoute><ProtectedShell><CampaignDetails /></ProtectedShell></ProtectedRoute>} />
          <Route path="/create-campaign" element={<ProtectedRoute><ProtectedShell><CreateCampaign /></ProtectedShell></ProtectedRoute>} />
          <Route path="/smart-links" element={<ProtectedRoute><ProtectedShell><SmartLinks /></ProtectedShell></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><ProtectedShell><Setting /></ProtectedShell></ProtectedRoute>} />
          <Route path="/campaign/:id" element={<ProtectedRoute><ProtectedShell><CampaignDetail /></ProtectedShell></ProtectedRoute>} />

          {/* Public smart link route for root-level slugs; static paths above will take precedence */}
          <Route path="/:slug" element={<PublicSmartLink />} />

          {/* Unauthenticated routes */}
          <Route path="/login" element={<UnauthenticatedRoute><Login /></UnauthenticatedRoute>} />
          <Route path="/register" element={<UnauthenticatedRoute><Register /></UnauthenticatedRoute>} />
          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
      <Toaster richColors closeButton />
    </ThemeProvider>
    </AuthProvider>
  );
}

export default App;